import { render, staticRenderFns } from "./RecentProjects.vue?vue&type=template&id=02a597f4&scoped=true&"
import script from "./RecentProjects.vue?vue&type=script&lang=js&"
export * from "./RecentProjects.vue?vue&type=script&lang=js&"
import style0 from "./RecentProjects.vue?vue&type=style&index=0&id=02a597f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a597f4",
  null
  
)

export default component.exports